module.exports = __webpack_public_path__ + "static/bg-e6b7baad464168c17ee3289a43b2dee1.jpg";